module.exports = __webpack_public_path__ + "img/13.fffd78b7.png";